import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { IconComponent, TypographyComponent } from 'components';
import { AiSummaryRatingDistributionItem } from '@brand-lolly/app/social-media-influencer/modules/social-listening/models/social-listening-ai-summary.model';

@Component({
	standalone: true,
	selector: 'app-ai-summary-rating-distribution',
	imports: [NgFor, NgIf, DecimalPipe, IconComponent, TypographyComponent],
	templateUrl: './ai-summary-rating-distribution.component.html',
	styleUrls: ['./ai-summary-rating-distribution.component.scss']
})
export class AiSummaryRatingDistributionComponent implements OnChanges {
	@Input() averageRating: number | null = null;
	@Input() reviewCount: number = 0;
	@Input() distribution: AiSummaryRatingDistributionItem[] = [];

	starsArray: boolean[] = [];
	/** Any star row with a review in it. */
	hasCounts = false;

	ngOnChanges(): void {
		const filled = Math.round(this.averageRating ?? 0);
		this.starsArray = Array.from({ length: 5 }, (_, i) => i < filled);
		this.hasCounts = this.distribution.some(item => item.count > 0);
	}
}
